import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import { USER_TUTORIAL_KEY } from '@/config';
import types from './mutation-types';

function subscribe(store) {
  store.subscribe((mutation, { Tutorials, Auth }) => {
    switch (mutation.type) {
      case types.SET_CHECKED_TUTORIALS: {
        if (!isEmpty(Auth.user)) {
          const cookieKey = `${USER_TUTORIAL_KEY}/${Auth.user.id}`;
          Cookies.set(cookieKey, Tutorials.checkedTutorials, { expires: 999 });
        }

        break;
      }

      case types.CHECK_TUTORIAL: {
        if (!isEmpty(Auth.user)) {
          const cookieKey = `${USER_TUTORIAL_KEY}/${Auth.user.id}`;
          Cookies.set(cookieKey, Tutorials.checkedTutorials, { expires: 999 });
        }

        break;
      }

      default: {
        break;
      }
    }
  });
}

export default (store) => {
  subscribe(store);
};



// WEBPACK FOOTER //
// ./src/app/tutorials/store/plugin.js